import { DISTANCE_UNITS } from '../../../constants/constants';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';

interface IProps {
  distance: number;
  placeName: string;
  placeUrl: string;
  distanceUnit: (typeof DISTANCE_UNITS)[keyof typeof DISTANCE_UNITS];
  isHidden?: boolean;
}

/**
 * Component to display an entry for a nearby place with its distance.
 *
 * @param {number} distance - The distance to the place.
 * @param {string} placeName - The name of the place.
 * @param {string} placeUrl - The URL to the place.
 * @param {keyof typeof DISTANCE_UNITS} distanceUnit - The unit of distance (e.g., miles, kilometers).
 * @param {boolean} [isHidden=false] - Whether the entry should be hidden.
 *
 * @returns {JSX.Element} The rendered component.
 */
export const NearbyPlaceEntry = ({
  distance,
  placeName,
  placeUrl,
  distanceUnit = DISTANCE_UNITS.MILES,
  isHidden = false,
}: IProps) => {
  return (
    <div className={`flex flex-col ${isHidden ? 'hidden' : ''}`}>
      <InternalLink to={placeUrl}>
        <Heading as="span" variant="2xs">
          {placeName}
        </Heading>
      </InternalLink>
      <Text variant="xs">{`${distance.toFixed(1)} ${distanceUnit} away`}</Text>
    </div>
  );
};
